import type { Place } from '../types/place'
import {
  placesFull,
  PLACES_COUNT_FULL,
  FULL_PASS_KWOTA,
  FULL_PLACES_PUBLISHED_COUNT,
  MINI_EDITION_TO_FULL_PLACE_IDS,
} from './placesFull'
import { placesMini, PLACES_COUNT_MINI } from './placesMini'

export type PassTier = 'mini' | 'full'

export {
  placesMini,
  placesFull,
  PLACES_COUNT_MINI,
  PLACES_COUNT_FULL,
  FULL_PASS_KWOTA,
  FULL_PLACES_PUBLISHED_COUNT,
  MINI_EDITION_TO_FULL_PLACE_IDS,
}

/** @deprecated Użyj placesMini lub getPlacesForTier */
export const placesMock = placesMini

/** @deprecated Użyj PLACES_COUNT_MINI lub getPlacesCountForTier */
export const PLACES_COUNT = PLACES_COUNT_MINI

export function getPlacesForTier(tier: PassTier): Place[] {
  return tier === 'full' ? placesFull : placesMini
}

export function getPlacesCountForTier(tier: PassTier): number {
  return tier === 'full' ? PLACES_COUNT_FULL : PLACES_COUNT_MINI
}

export function getPlaceById(tier: PassTier, id: number): Place | undefined {
  return getPlacesForTier(tier).find((p) => p.id === id)
}

export function isPlaceInTier(placeId: number, tier: PassTier): boolean {
  return getPlaceById(tier, placeId) !== undefined
}

export function defaultPassTierForNewCheckout(): PassTier {
  return 'mini'
}
